import { useCustomerContext } from "../../../Context/CustomerContext";

export const useWidgetCustomer = () => {
  const { customerOrPresentationModeCustomer: customer, customer: originalCustomer } = useCustomerContext();
  return originalCustomer.presentationMode?.customerId === customer.id ? originalCustomer : customer;
};
